import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = () => {
      const user = localStorage.getItem("user_id");
      if (!user) {
        navigate("/login");
      } else {
        setTimeout(() => setIsLoading(false), 500);
      }
    };
    checkUser();
  }, [navigate]);

  const toggleSidebar = () => setSidebarOpen((v) => !v);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Allow scrolling globally
    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [sidebarOpen]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col items-center justify-center">
        <div className="w-20 h-20 relative">
          <div 
            className="w-20 h-20 rounded-full border-t-4 border-b-4 animate-spin" 
            style={{ borderColor: "rgb(4, 138, 173)" }}
          />
          <div
            className="w-20 h-20 rounded-full border-r-4 border-l-4 border-transparent animate-spin absolute top-0 left-0"
            style={{ 
              borderRightColor: "#01CC54",
              animationDirection: "reverse", 
              animationDuration: "1s" 
            }}
          />
        </div>
        <h2 className="mt-6 text-2xl font-bold text-gray-900">
          Loading BluTec PING...
        </h2>
        <p className="text-gray-600 text-sm mt-2">
          Please wait while your dashboard is prepared
        </p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main content wrapper - 80px (20rem) margin for sidebar on desktop */}
      <div className="flex-1 lg:ml-20 flex flex-col min-h-screen">
        {/* Fixed Header */}
        <Header toggleSidebar={toggleSidebar} />

        {/* Main content with top padding for fixed header */}
        <main className="flex-1 pt-14 md:pt-16">
          <div className="w-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;